<div class="container">
  <div class="gti_pop_ban">
    <img lazyLoad="assets/img/gen_catalogoue.png" class="img-fluid">
    <h3>Catalogue</h3>
    <p *ngIf="!catalogs || catalogs.length === 0">No catalogs available.</p>
    <div *ngIf="catalogs.length > 0">
      <div *ngFor="let catalog of catalogs">
        <a [href]="catalog.url">{{ catalog.title }}</a>
      </div>
    </div>
  </div>
</div>
